import { backendClient } from "@/lib/backend-api";
import { useQuery } from "@tanstack/react-query";

export const useAppEmbedStatus = () => {
  return useQuery({
    queryKey: ["app-embed-status"],
    queryFn: () => backendClient.shop.getAppEmbedStatus(),
    staleTime: 0,
    gcTime: 0,
  });
};
